export default {
      id: "restore-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#restore-usage",
      toString: function () {
        return this.url;
      }
    }